import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Divider, Icon, Button, Row, Tooltip, Form, Col, Pagination, Collapse, Rate} from 'antd';
import {Field, reduxForm} from "redux-form";
import TextField from '../formFields/TextField';
import Loading from '../loading/loading';
import SelectField from "../formFields/SelectField";
import DatePickerField from "../formFields/DatePickerField";
import moment from "jalali-moment";

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        width:'4%'
    },
    {
        title: 'کد سیستمی',
        dataIndex: 'system_code',
        sorter: (a, b) => a.system_code - b.system_code,
        width:"10%"
    },
    {
        title: 'عنوان',
        dataIndex: 'title',
        width:"10%"
    },
    {
        title: 'دسته بندی',
        dataIndex: 'product_category',
        width: "10%"
    },
    {
        title: 'توضیحات',
        dataIndex: 'description',
        width:"15%"
    },
    {
        title: 'تعویض دوره ای',
        dataIndex: 'is_need_replacement',
        sorter: (a, b) => a.is_need_replacement - b.is_need_replacement,
        width:"10%"
    },
    {
        title: 'انبار مرکزی',
        dataIndex: 'central_warehouse',
        sorter: (a, b) => a.centarl_warehouse - b.centarl_warehouse,
        width:"7%"
    },
    {
        title: 'قیمت',
        dataIndex: 'price',
        sorter: (a, b) => a.price.length - b.price.length,
        width:"7%"
    },
    {
        title: 'پورسانت',
        dataIndex: 'commission',
        sorter: (a, b) => a.commission.length - b.commission.length,
    },
    {
        title: 'عملیات',
        dataIndex: 'action',
        width:"15%"
    },
];

const logsColumn = [
    {
        title: 'ردیف',
        dataIndex: 'key',
    },
    {
        title: 'نام و نام خانوادگی',
        dataIndex: 'fullName',
    },
    {
        title: 'کد سیستمی',
        dataIndex: 'system_code',
    },
    {
        title: 'توضیحات',
        dataIndex: 'operation_title',
    },
    {
        title: 'تاریخ',
        dataIndex: 'date',
    },
];

const expandedRowRender = record => <div>{record.extraInfo}</div>;

class List extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:false,
            pageSize:10,
            current: (this.props.list ? this.props.list.pageNumber : 1),
            expandedRowRender,
            filter:[],
            title:''
        }
        this.__onChangeCounter = this.__onChangeCounter.bind(this)
    }

    componentWillMount() {
        this.props.getList();
        this.props.getCategoryList();
    }

    /*--- pagination ---*/
    async handlePageChange(pageNumber) {
                console.log("this.state : ",this.state)
        clearInterval(this.interval);
        this.setState({current: pageNumber});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:pageNumber}
        }))
        this.props.getList(this.state.filter);
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        var list = this.props.list;
        var dataSource = [];
        var extraInfo;
        const { Panel } = Collapse;

        if(list && list.lists) {
            for (let i = 0; i < list.lists.length; i++) {
                let logs = [];
                let replacementIcon;

                /*---- logs ----*/
                if(list.lists[i].status_history) {
                    for (let j = 0; j < list.lists[i].status_history.length; j++) {
                        logs.push({
                            key: (j + 1),
                            system_code: list.lists[i].status_history[j].system_code ? list.lists[i].status_history[j].system_code : '',
                            fullName: list.lists[i].status_history[j].fullname ? list.lists[i].status_history[j].fullname : '',
                            operation_title: list.lists[i].status_history[j].operation_title ? list.lists[i].status_history[j].operation_title : '',
                            date: list.lists[i].status_history[j].operation_date ? moment(list.lists[i].status_history[j].operation_date).format('jYYYY/jM/jD') : '',
                        });
                    }

                }

                if(list.lists[i])
                    extraInfo = <Collapse className="extraInfoWrapper">
                        <Panel header="مشاهده سابقه" key="1">
                            {list.lists[i].status_history ?
                                <Row className="collapseText">
                                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } pagination={false} columns={logsColumn} dataSource={logs} size="small" />
                                </Row>
                                :null}
                        </Panel>
                    </Collapse>
                else
                    extraInfo = ''

                if(list.lists[i].is_need_replacement)
                    replacementIcon = <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
                else
                    replacementIcon = <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />
                dataSource.push({
                    key: (this.state.pageSize*(list.page_number-1))+(i+1),
                    system_code: list.lists[i].system_code,
                    product_category: list.lists[i].product_category.title,
                    title: list.lists[i].title,
                    description: list.lists[i].description,
                    is_need_replacement : replacementIcon,
                    central_warehouse : list.lists[i].inventory,
                    price: (list.lists[i].price).toLocaleString(navigator.language, { minimumFractionDigits: 0 }),
                    commission: (list.lists[i].commission).toLocaleString(navigator.language, { minimumFractionDigits: 0 }),
                    extraInfo,
                    action: <span>
                                <Tooltip placement="top" title="ویرایش">
                                    <a href={"#/product/edit/"+list.lists[i]._id} className="listBtn"><Icon type="edit" /></a>
                                </Tooltip>
                                {(list.lists[i].product_type === 'PRODUCT_CATEGORY_TECHNICIAN_TYPE' ?
                                <Divider type="vertical" />
                                : null)}
                                {(list.lists[i].product_type === 'PRODUCT_CATEGORY_TECHNICIAN_TYPE' ?
                                <Tooltip placement="top" title="انبار">
                                    <a href={"#/warehouse/add/"+list.lists[i]._id} className="blueListBtn"><Icon type="dropbox" /></a>
                                </Tooltip>
                                : null)}
                                {(list.lists[i].product_type === 'PRODUCT_CATEGORY_TECHNICIAN_TYPE' ?
                                <Divider type="vertical" />
                                : null)}
                                {(list.lists[i].product_type === 'PRODUCT_CATEGORY_TECHNICIAN_TYPE' ?
                                <Tooltip placement="top" title="گزارش انبار">
                                    <a href={"#/warehouse/product/"+list.lists[i]._id} className="purpleListBtn"><Icon type="bars" /></a>
                                </Tooltip>
                                : null)}
                                {(list.lists[i].product_type === 'PRODUCT_CATEGORY_TECHNICIAN_TYPE' ?
                                    <Divider type="vertical" />
                                : null)}
                                {(list.lists[i].product_type === 'PRODUCT_CATEGORY_TECHNICIAN_TYPE' ?
                                <Tooltip placement="top" title="مشاهده انبار">
                                    <a href={"#/warehouse/list/product/"+list.lists[i]._id} className="greenListBtn2"><Icon type="pie-chart" /></a>
                                </Tooltip>
                                : null)}
                            </span>
                });
            }
        }
        return dataSource;
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    /*-- search form ---*/
    onFormSubmit(value) {
        if(this.state.system_code)
            this.setState(prevState  => ({
                filter: {...prevState.filter,title:this.state.title}
            }))
        if(this.state.invoiceStatus)
            this.setState(prevState  => ({
                filter: {...prevState.filter,invoiceStatus:this.state.invoiceStatus}
            }))
        this.props.handleSubmit(value);
        clearInterval(this.interval);
    }

    async __onChangeCounter(current, pageSize) {
        clearInterval(this.interval);
        this.setState({size:pageSize});
        this.setState({pageSize:pageSize})
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:current,size:pageSize}
        }))
        this.props.getList(this.state.filter);
    }

    __clearFilter() {
        this.props.reset();
        this.props.getList();
        this.setState({current:1})
    }

    __getCategoryList() {
        let categoryList = this.props.categoryList;
        let dataSource = [];

        if (categoryList) {

            for (let i = 0; i < categoryList.lists.length; i++) {

                dataSource.push(
                    {label: categoryList.lists[i].title, value: categoryList.lists[i]._id, key: i}
                );

            }

        }
        return dataSource;
    }

    __goBack(){
        this.props.history.goBack()
    }

    render() {
        var _self = this;
        const { searchBoxHidden,pageSize } = this.state;
        const { list } = this.props;

        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={18}>
                        <Divider orientation="left">لیست محصولات</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={6} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="search" onClick={this.__toggleSearchBox.bind(this)} ></RTLButton>
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="plus" href="#/product/add">
                            ایجاد محصول
                        </RTLButton>
                    </RTLCol>
                </Row>
                <Row>
                    <Form name="search" onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                        <Row gutter={4} type="flex" justify="start" align="top" hidden={searchBoxHidden} >
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="title"
                                    component={TextField}
                                    type="text"
                                    placeholder="عنوان"
                                    onBlur={(e) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,title:e.target.value}
                                    }))}
                                    // onChange={(e) => this.setState({title:e.target.value})}
                                    defaultValue={this.state.title}
                                    value={this.state.title}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="product_category"
                                    component={SelectField}
                                    placeholder="دسته بندی"
                                    list={this.__getCategoryList()}
                                    onChange={(product_category) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,product_category:product_category}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="product_type"
                                    component={SelectField}
                                    placeholder="نوع محصول"
                                    list={[
                                        {label: 'مشتری', value: 'PRODUCT_CATEGORY_CUSTOMER_TYPE', key: 1},
                                        {label: 'تکنسین', value: 'PRODUCT_CATEGORY_TECHNICIAN_TYPE', key: 2}
                                    ]}
                                    onChange={(product_type) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,product_type:product_type}
                                    }))}
                                />
                            </RTLCol>
                            {/* <RTLCol sm={12} md={4}>
                                <Field
                                    name="invoiceStatus"
                                    component={SelectField}
                                    placeholder="وضعیت فاکتور"
                                    list={[
                                        {label: 'در فاکتور ها باشد', value: 'inInvoice', key: 1},
                                        {label: 'در فاکتور ها نباشد', value: 'notInInvoice', key: 2}
                                    ]}
                                    onChange={(invoiceStatus) => {
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,invoiceStatus:invoiceStatus}
                                        }))
                                    }}
                                />
                            </RTLCol> */}
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="from"
                                    component={DatePickerField}
                                    placeholder="از تاریخ"
                                    timePicker={false}
                                    onChange={(from) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,from:from}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="to"
                                    component={DatePickerField}
                                    placeholder="تا تاریخ"
                                    timePicker={false}
                                    onChange={(to) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,to:to}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton className="left" type="default" shape="round" onClick={this.__clearFilter.bind(this)}>
                                    بروزرسانی
                                </RTLButton>
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                 <RTLButton loading={this.props.common.isProgressing} className="left" type="primary" shape="round" htmlType="submit">
                                    جستجو
                                </RTLButton>
                            </RTLCol>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } {...this.state} pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                    <Loading list={list} />
                </Row>
                <Row type="flex" justify="space-between">
                    <RTLCol md={14} className="right">
                        <Pagination
                            name="pageNum"
                            current={this.state.current}
                            total={(list ? list.count : this.state.pageSize)}
                            onChange={(pageNum) => this.handlePageChange(pageNum)}
                            pageSizeOptions={['10', '20','30','40','50','60','70','80','90','100']}
                            showSizeChanger
                            onShowSizeChange={this.__onChangeCounter}
                        />
                    </RTLCol>
                    <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                        بازگشت
                    </RTLButton>
                </Row>
            </div>
        );
    }
}

export default List = reduxForm({
    form: 'list'
})(List)
